import { modules } from "../../components/modules";
import { FLOW_MESSAGES } from "../../components/shared/components/flowMessages/components";

export const flowWelcomeAndTerms = {
  name: "Welcome and Terms",
  modules: [
    {
      id: modules.SLIDER.id,
      section: {
        name: null,
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.participant.participantId,
        welcomeMessageId: FLOW_MESSAGES.APP_START.id,
      },
    },
    {
      id: modules.TERMS.id,
      section: {
        name: null,
      },
      onAppResume: {
        conditionsToBeInitialModuleInFlow: (processState) =>
          !processState.loan?.borrower_user_details_on_origination,
        welcomeMessageId: FLOW_MESSAGES.WELCOME_BACK.id,
      },
    },
  ],
};
